import React from "react";
import { Layout } from "../components/Layout";
import { useI18nL10nContext } from "gatsby-plugin-i18n-l10n";
import { Card } from "flowbite-react";
import { getSrcImg } from "../blog";
import { formatDate } from "../utils/date";
import SEO from "../components/SEO";
import { getPostLanguageAlternatives } from "../utils/languageUtils";
import { useLocation } from "@reach/router";

const BlogPostTemplate = ({ pageContext }) => {
  const {
    title,
    content,
    publishDate,
    featuredImage,
    latestPosts=[],
    seoTitle,
    metaDescription,
  } = pageContext;
  const { locale } = useI18nL10nContext();
  const location = useLocation();

  const languageAlternatives = getPostLanguageAlternatives(
    location.pathname,
    pageContext.slug,
  );

  return (
    <>
      <SEO
        languageAlternatives={languageAlternatives}
        title={seoTitle}
        description={metaDescription}
      />
      <Layout showLanguageSwitcher={false}>
        <div
          className="w-full h-96 relative mb-12 bg-center bg-cover"
          style={{ backgroundImage: `url(${getSrcImg(featuredImage)})` }}
        >
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: " 100%",
              background:
                "linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0.4), transparent)",
            }}
          />

          <div className="container mx-auto px-4 h-full flex items-end">
            <div className="relative text-white pb-12">
              <div className="mb-4">
                <time className="ml-4 text-gray-300">
                  {formatDate(publishDate)}
                </time>
              </div>
              <h1 className="text-4xl md:text-5xl font-bold max-w-3xl">
                {title}
              </h1>
            </div>
          </div>
        </div>

        <div className="container mx-auto px-4 mb-6 mt-6">
          <div className="lg:flex lg:gap-8">
            <main className="min-w-0 flex-1">
              <Card>
                <div className="prose max-w-none">
                  <div dangerouslySetInnerHTML={{ __html: content }} />
                </div>
              </Card>
            </main>

            <aside className="lg:w-[350px] flex-shrink-0 ">
              <div className="sticky top-24 ">
                <Card>
                  <h2 className="text-2xl font-bold">Latest news</h2>
                  <div className="space-y-6">
                    {latestPosts.map((post, index) => (
                      <a
                        key={index}
                        href={`/blog/${post.slug[locale]}`}
                        className="block hover:bg-gray-50 rounded-lg transition-colors"
                      >
                        <div className="flex gap-4 p-2">
                          <img
                            src={getSrcImg(post.ArticleImage.iv?.[0])}
                            alt={post.Headline[locale]}
                            className="w-20 h-20 object-cover rounded"
                          />
                          <div className="flex-1 min-w-0">
                            <h3 className="font-bold line-clamp-2">
                              {post.Headline[locale]}
                            </h3>
                            <time className="text-sm text-gray-500">
                              {formatDate(post.PublishingDate.iv)}
                            </time>
                          </div>
                        </div>
                      </a>
                    ))}
                  </div>
                </Card>
              </div>
            </aside>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default BlogPostTemplate;
